import { atom } from 'jotai';
import { IToast } from '../components/molecules/ToastMessage';
import { store } from '.';
import { v4 } from 'uuid';

export const toastAtom = atom<IToast[]>([]);

export const toast = {
  add: (info: IToast) => {
    const queue = store.get(toastAtom);
    info.id = v4();
    store.set(toastAtom, [...queue, info]);
  },
  shift: () => {
    const queue = [...store.get(toastAtom)];
    if (queue.length) {
      queue.shift();
      store.set(toastAtom, queue);
    }
  },
  // R9: validation toasts are screen-scoped. A toast surviving navigation renders a stale
  // (and possibly wrong-for-this-screen) message at the top of the next page - e.g. an
  // acceptable-range message for a DIFFERENT part misleading the current entry.
  clear: () => {
    if (store.get(toastAtom).length) {
      store.set(toastAtom, []);
    }
  },
};
